import React from 'react'
import './styles.scss'
import quote from 'assets/portfolio/image/QuoteLeft.png'

const FeedBackCard = (props) => {
  return (
    <div className="main-frame-feedback-section">
      {props.FeedBackData.map((item, index) => (
        <div className="feedback-card" key={index}>
          <div className="frame-img-icon-feedback">
            <img src={quote} alt="" />
          </div>
          <div className="frame-content-feebback">
            <p>{item.content}</p>
          </div>
          <hr className="line-feedback" />
          <div className="frame-img-intern-feedback">
            <img src={item.img} alt="" />
          </div>
          <div className="frame-name-position">
            <p className="p-name-feedback">{item.name}</p>
            <p className="p-position">FRONTEND INTERN</p>
          </div>
        </div>
      ))}
    </div>
  )
}

export default FeedBackCard
